import GroupIcon from '@mui/icons-material/Group';
import { t } from 'i18next';
import CrudBase from "src/components/CrudBase";
import Client from 'src/models/client';
import ClientForm from './ClientForm';

export function Clients() {
    return (
        <CrudBase<Client>
            resource="clients"
            indexColumns={['rfc', 'name']}
            showModalColumns={['rfc','name','created_at','updated_at']}
            Form={ClientForm}
            deleteButton={true}
            searchInput={true}
            Icon={GroupIcon} />
    );
}
